import React from 'react'
import { Modal } from 'reactstrap'
import classNames from 'classnames'

import Row from "../Layout/Row";
import Image from "../Image";

import { closeIcon_over, closeIcon_popUp, saveIcon_over, saveIcon_popUp } from 'img/icons'
import style from './_modal.module.scss'


export default function ElementModal({ error, isOpen, onClose, submit, submitButtonDisabled = false, className = classNames(style.modal), children }) {
		return (
			<Modal isOpen={isOpen} toggle={onClose} className={className}>

				{error && <div className={style.error}>{error}</div>}

				{children}
				<Row className={style.buttons}>
					{(submitButtonDisabled) ? <></> : (
						<Image
							src={saveIcon_popUp}
							hover={saveIcon_over}
							onClick={submit}
						/>
					)}
					<Image
						src={closeIcon_popUp}
						hover={closeIcon_over}
						onClick={onClose}
					/>
				</Row>
			</Modal>
		);
}
